var render, staticRenderFns
import script from "./NIconBtn.vue?vue&type=script&lang=js"
export * from "./NIconBtn.vue?vue&type=script&lang=js"
import style0 from "./NIconBtn.vue?vue&type=style&index=0&id=bf254770&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports